import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-x8"
}
const _hoisted_2 = {
  key: 0,
  class: "md:flex"
}
const _hoisted_3 = {
  key: 1,
  class: "w-full text-center"
}
const _hoisted_4 = ["disabled"]

import { useCheckout } from '@/storecontext/checkout/useCheckout';
import {
    CheckOutDeliverable,
    CheckOutDeliverableWithAddress,
    ClickAndCollectCheckOutDeliverable,
    CustomerDeliveryCheckOutDeliverable,
    PickUpCheckOutDeliverable,
} from '@/storecontext/shared/api/server-apis';
import { computed, withDefaults } from 'vue';
import CheckoutPaymentOptions from '@/storecontext/checkout/ui/payment/CheckoutPaymentOptions.vue';
import TermsAndConditions from '@/storecontext/shared/checkout/ui/TermsAndConditions.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutDeliverableGoToNext',
  props: {
    deliverable: null,
    index: null,
    isClientValid: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { deliverable: CheckOutDeliverable | CheckOutDeliverableWithAddress | CustomerDeliveryCheckOutDeliverable | PickUpCheckOutDeliverable | ClickAndCollectCheckOutDeliverable, index: number, isClientValid: boolean }



const labels = useBlockLabels();
const { step, gotoNextStep, basket, isLastStep } = useCheckout();
const isActiveDeliverable = computed(() => step.value === props.index + 1);

const allowGoToNextDelivery = computed<boolean>(() => {
    const isServerValid = props.deliverable.isValid;
    const isClientValid = props.isClientValid;
    return isServerValid && isClientValid;
});

const goToNextDelivery = ():void => {
    if (allowGoToNextDelivery.value) {
        gotoNextStep();
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "o-anim-fade-300" }, {
    default: _withCtx(() => [
      (_unref(isActiveDeliverable))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_unref(isLastStep))
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(TermsAndConditions, {
                    label: _unref(labels).paymentSelectTermsAndConditions,
                    class: "mr-auto min-w-180 mb-x3 mb:mb-0"
                  }, null, 8, ["label"]),
                  _createVNode(CheckoutPaymentOptions, {
                    "is-client-valid": _unref(allowGoToNextDelivery),
                    class: "md:ml-x2 u-valign-inline-button"
                  }, null, 8, ["is-client-valid"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "c-button c-button--primary",
                    disabled: !_unref(allowGoToNextDelivery),
                    onClick: goToNextDelivery
                  }, _toDisplayString(_ctx.$dictionary.formatNamed(_unref(labels).continueToNextDeliverableButton, { step: __props.index + 2, steps: _unref(basket).deliverables.length })), 9, _hoisted_4)
                ]))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})